import { defineStore } from 'pinia';

export const useTableFilterStateStore = defineStore('tableFilterState', {
  state: (): { filterStrings: Record<string, string> } => ({
    filterStrings: {},
  }),
  actions: {
    setFilterString(dataKey: string, filter: string) {
      this.filterStrings[dataKey] = filter;
    },
    getFilterString(dataKey: string) {
      const filter = this.filterStrings[dataKey] || '';
      return filter;
    },
  },
  persist: {
    storage: localStorage,
  },
});
